import Vue from "vue";
import Vuex from "vuex";

import layout from "@/core/store/modules/layout";
import account from "@/core/store/modules/account";
import auth from "@/core/store/modules/auth";
import captcha from "@/core/store/modules/captcha";
import errors from "@/core/store/modules/errors";
import generic from "@/core/store/modules/generic";
import notification from "@/core/store/modules/notification";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        account,
        captcha,
        errors,
        generic,
        layout,
        notification
    }
});
